import { routes } from './clients.routes';
import LmeListClientsController from "./directory/directory.controller";
import LmeDetailsClientsController from "./details/details.controller";
export default angular.module('app.lab.clients', [])
    .config(routes)
    .controller('LmeListClientsController', LmeListClientsController)
    .controller('LmeDetailsClientsController', LmeDetailsClientsController)
    .name;
